import { styled } from '../../../../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const LogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 200px;
    object-fit: contain;
`;

export const TitleBar = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 16px 20px;
    gap: 12px;
    border-bottom: 1px solid #edf2f7;
    flex-shrink: 0;
`;

export const Title = styled.h1<{ $color: string }>`
    flex: 1;
    font-size: 16px;
    font-weight: 600;
    color: ${({ $color }) => $color};
    margin: 0;
    line-height: 1.3;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const BackIconButton = styled.button<{ $color: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid ${({ $color }) => $color};
    background-color: ${({ $color }) => `${$color}11`};
    color: ${({ $color }) => $color};
    cursor: pointer;
    flex-shrink: 0;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.85;
    }
`;

export const ViewerContainer = styled.div`
    flex: 1;
    width: 100%;
    background-color: #f5f7fa;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const DocumentFrame = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
    display: block;
`;

export const FallbackBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 24px;
    text-align: center;
    color: #4a5568;
    font-size: 14px;
    height: 100%;
`;

export const Footer = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 20px;
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    flex-shrink: 0;
`;

export const OutlineButton = styled.button<{ $color: string }>`
    width: 100%;
    padding: 15px 20px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    background-color: ${({ $color }) => `${$color}33`};
    border: 1px solid ${({ $color }) => $color};
    color: ${({ $color }) => $color};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.85;
    }
`;

export const FallbackLink = styled.a<{ $color: string }>`
    color: ${({ $color }) => $color};
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
`;
